import React, { Fragment, PureComponent } from 'react';
import PropTypes from "prop-types";

import { makeStyles } from "@material-ui/core/styles";
import ListItem from '@material-ui/core/ListItem';
import ArrowRightIcon from '@material-ui/icons/ArrowRight';

import MaybeLink from '../util/MaybeLink';
import TextUtil from '../util/TextUtil';
import "../fgfStyles.css"

const useStyles = makeStyles((_) => ({
    item: {
        padding: 0,
        marginTop: 16,
        marginBottom: 16,
    },
    icon: {
        minWidth: 32,
        color: '#1d89bf',
    },
    text: {
        '&:hover': {
            textDecoration: 'underline',
        },
        marginTop: 0,
    },
    footer_text:{
        '&:hover': {
            textDecoration: 'underline',
        },
        marginTop: 0,
    },
    link: {
        '&:focus-visible': {
            outline: '2px solid #888888',
            borderRadius: 6,
        },
    },
    divider: {
        height: 2,
        backgroundColor: '#f3f1f3',
        marginBottom: 8,
    },
}));

class DpaLinkItem extends PureComponent {
    render() {
        const { classes, title, footer, url, right, smallPadding } = this.props;
        var style = {display: 'flex', justifyContent: 'flex-start', marginTop: 16};
        if(right)
            style = {display: 'flex', justifyContent: 'flex-end', marginTop: 16};
        if(footer) {
            style = {display: 'flex', justifyContent: 'flex-end', marginTop: 0};
        }
        if(smallPadding) {
            style = {display: 'flex', justifyContent: 'flex-start', marginTop: 12, marginBottom: 12};
            if(right)
                style = {display: 'flex', justifyContent: 'flex-end', marginTop: 12, marginBottom: 12};
            if(footer) {
                style = {display: 'flex', justifyContent: 'flex-end', marginTop: 0, marginBottom: 12};
            }
        }
        if (TextUtil.isEmptyText(title)) {
            return null;
        } else {
            return (
                <Fragment >
                    <ListItem style={style}
                        disableGutters={true}
                        classes={{ root: classes.item, }}>
                        <MaybeLink
                            to={url}

                            className={`link ${footer ? classes.footer_text : classes.text}`}
                        >
                            <div className={`link ${footer ? classes.footer_text : classes.text}`} style={{display:'inline-block'}}>
                                | {TextUtil.relaceQuotationMarks(title)}
                            </div>
                        </MaybeLink>
                    </ListItem>

                </Fragment>
            );
        }
    }
}

DpaLinkItem.propTypes = {
    title: PropTypes.string,
    url: PropTypes.string,
    footer: PropTypes.bool,
    right: PropTypes.bool,
    userLang: PropTypes.string,
    smallPadding: PropTypes.bool,
};

export default function _DpaLinkItem(props) {
    const classes = useStyles();
    return <DpaLinkItem {...props} classes={classes} />;
}
